import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import React from 'react';

function AddColumnForm({ isModalOpen, handleCloseModal, columnForm, setColumnForm, handleSaveColumnForm }) {
  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setColumnForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setColumnForm({
      column_name: '',
      data_type: '',
    });
    handleCloseModal();
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleCloseModal}
      PaperProps={{
        style: {
          // minHeight: '400px',

          maxWidth: '500px',
        },
      }}
    >
      <DialogTitle>Add Column</DialogTitle>
      <DialogContent>
        <div style={{ width: 400, marginTop: '2px' }}>
          <TextField
            id="outlined-select-columnName"
            // select
            required
            name="column_name"
            label="Column Name"
            size="small"
            value={columnForm.column_name || ''}
            onChange={(e) => handleFieldChange(e)}
            autoComplete="off"
            style={{ width: '100%', marginTop: '5px' }}
          />
          <TextField
            id="outlined-select-dataType"
            select
            required
            name="data_type"
            label="Data Type"
            size="small"
            onChange={(e) => handleFieldChange(e)}
            value={columnForm.data_type || ''}
            autoComplete="off"
            style={{ width: '100%', marginTop: '8px' }}
          >
            <MenuItem value="number">Number</MenuItem>
            <MenuItem value="float">Float</MenuItem>
            <MenuItem value="string">String</MenuItem>
          </TextField>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSaveColumnForm} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddColumnForm;
